module.exports = __webpack_public_path__ + "img/question-icon.9adc6d74.svg";